import React, { Component } from 'react';
import { Row, Col, Table, Button, Input, Popconfirm, message, Checkbox, Switch, Modal, Divider, Pagination } from 'antd';
import Title from 'antd/lib/typography/Title';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification, NetworkDelaySearch, formatMoney, showSuccessInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';

const sources_cols = ({ onAssignData }) => [
  {
    title: "Name",
    dataIndex: "name",
    key: 'name'
  }, {
    title: "",
    dataIndex: "id",
    key: 'id',
    width: 20,
    render: (id,record) => {
      return <div style={{
        display:'flex',
        gap:10,
        alignItems:'center'
      }}>
        <Button
          type='link'
          title='Assign all the sources of this group.'
          style={{ padding: 0 }}
          onClick={() => {
            typeof onAssignData === 'function' && onAssignData(id)
          }}>Assign</Button>
      </div>
    }
  }
]
const all_data_cols = ({ 
  onClickViewSources,
  onClickSelectSource,
  onClickAssignAll,
  onClickRemoveAll

}) => [
  {
    title: "Name",
    dataIndex: "group_name",
    key: 'group_name'
  }, 
  {
    title: "Sources",
    dataIndex: "id",
    key: 'id',
    width:100,
    render:(id,record)=>{

      const assigned=Object.keys(record.assigned??{});
      const total_sources=Object.keys(record.total_sources??{});
      return `${assigned.length}/${total_sources.length}`
    }
  }, 
  {
    title: "",
    dataIndex: "id",
    key: 'id',
    width: 20,
    render: (id,record) => {
      return <div style={{
        display:'flex',
        gap:10,
        alignItems:'center'
      }}>
        {/* <Button
          type='link'
          title='View assigned sources for this group.'
          style={{ padding: 0 }}
          onClick={() => {
            typeof onClickViewSources === 'function' && onClickViewSources(record)
          }}>View Sources</Button>
          <Divider type='vertical'/> */}
        <Button
          type='link'
          title='Select Sources of this group to assign.'
          style={{ padding: 0 }}
          onClick={() => {
            typeof onClickSelectSource === 'function' && onClickSelectSource(record)
          }}>Select Sources</Button>
           <Divider type='vertical'/>
        <Button
          type='link'
          title='Assign all the sources from this group.'
          style={{ padding: 0 }}
          onClick={() => {
            typeof onClickAssignAll === 'function' && onClickAssignAll(record)
          }}>Assign All</Button>
           <Divider type='vertical'/>
           <Button
          type='link'
          title='Remove all assigned sources from this group.'
          style={{ padding: 0,color:'red'}}
          onClick={() => {
            typeof onClickRemoveAll === 'function' && onClickRemoveAll(record)
          }}>Remove All</Button>
      </div>
    }
  }
]
const user_data_cols = ({ onRemoveData,onToggleAccess }) => [
  {
    title: "Name",
    dataIndex: "name",
    key: 'name'
  }, 
  {
    title: "Write Access",
    dataIndex: "write_flag",
    key: 'write_flag',
    render:(access,data)=>{
      return <Switch checked={access} onChange={(checked)=>{
        typeof onToggleAccess==='function'&&onToggleAccess(data.id,checked)
      }} />
    }
  }, 
  {
    title: "",
    dataIndex: "id",
    key: 'id',
    width: 20,
    render: (id) => {
      return <span>
        <Popconfirm arrowPointAtCenter placement='topLeft' title="Are you sure you want to remove this Group for user?"
          onConfirm={() => {
            typeof onRemoveData === 'function' && onRemoveData(id)
          }}>
          <Button
            type='link'
            style={{
              color: 'red',
              padding: 0
            }}
          >Remove</Button>
        </Popconfirm>
      </span>
    }
  }
]

class GroupAssigner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      all_filter: {
        per_page: 100,
        page: 1
      },
      selectedGroupForAssign:{},
      selectedGroupForView:{},
      selectedSourceIds:[],
    };

    this.list_groups = RESTExecutor.list().config({
      label: 'assigned_group_sources',
      params: {
        ...this.state.all_filter
      }
    }).callbacks((success) => {
    }, (error) => {
    }).forId(this.props.user_id).connect(props.domains.users);


    //called when group is selected to  view sources or to update source access
    this.listSourcesForGroupExecutor=RESTExecutor.list().config({
      label:'sourcegroup_list',
      params:{
        //group_id
      }
    }).connect(props.domains.groups);

    this.assignAllSourcesForGroupExecutor=RESTExecutor.post().config({
      label:'assign_all_source_from_group',
      params:{
        //group_id
      }
    })
    .forId(this.props.user_id)
    .callbacks((success)=>{
      this.list_groups.execute();
      showSuccessInNotification(success,"Assigned all sources from selected group")
    },(error)=>{
      showErrorInNotification(error);
    })
    .connect(props.domains.users);

    this.assignSelectedSourcesForGroupExecutor=RESTExecutor.post().config({
      label:'assign_selected_sources',
    })
    .forId(this.props.user_id)
    .callbacks((success)=>{
      this.setState({
        selectedGroupForAssign:{},
        selectedSourceIds:[]
      })
      this.list_groups.execute();
      showSuccessInNotification(success,"Assigned selected sources")
    },(error)=>{
      showErrorInNotification(error);
    })
    .connect(props.domains.users);

    this.removeAllSourcesForGroupExecutor=RESTExecutor.post().config({
      label:'remove_all_source_from_group',
    })
    .forId(this.props.user_id)
    .callbacks((success)=>{
      // this.stateUpdater({
      //   stateKey: 'all_filter',
      //   appendObj: {
      //     page: 1
      //   },
      //   callback: () => {
      //     this.list_groups.config({
      //       params: {
      //         ...this.state.all_filter
      //       }
      //     }).execute();
      //   }
      // });
      this.list_groups.execute();
      showSuccessInNotification(success,"Removed all sources from selected group");
    },(error)=>{
      showErrorInNotification(error);
    })
    .connect(props.domains.users);



    this.assign_data = RESTExecutor.post().config({
      label: 'assign_all_sources'
    }).callbacks((success) => {
      this.stateUpdater({
        stateKey: 'all_filter',
        appendObj: {
          page: 1
        },
        callback: () => {
        }
      });
      message.success("All Sources for a group is assigned to the user");
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.modify_data=RESTExecutor.patch().config({
      label: 'assigned_groups_detail',
      
    }).callbacks((success) => {
      this.stateUpdater({
        stateKey: 'all_filter',
        appendObj: {
          page: 1
        },
        callback: () => {
          // this.list_groups.config({
          //   params: {
          //     ...this.state.all_filter
          //   }
          // }).execute();
        }
      });

      message.success("Assigned Sources modified");
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

  
    this.delay_1=new NetworkDelaySearch();
    this.delay_2=new NetworkDelaySearch();

    this.list_groups.execute();
  };



  onSelectSource=(id)=>{
    let newId=this.state.selectedSourceIds??[];
    const indexNumber=newId.indexOf(id);
    if(indexNumber===-1){
        newId.push(id);
    }else{
        newId.splice(indexNumber,1);
    }
    
    console.log("indexNumber",indexNumber,newId)
    this.setState({
      selectedSourceIds:newId
    })
  }

  stateUpdater = ({
    stateKey,
    removeKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    if (removeKey) {
      delete newData[removeKey]
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {
    const { all_filter, assigned_filter ,selected_group,selectedGroupForAssign,selectedSourceIds} = this.state;

    let list_groups_resp = this.list_groups.response();

    


    let list_groups_rows = (list_groups_resp.result?.rows) || [];

    let list_groups_meta = list_groups_resp?.meta || {};



    let listSourcesForGroupExecutorResp=this.listSourcesForGroupExecutor.response();
    let sourceListForGroup=listSourcesForGroupExecutorResp?.result?.rows??[]
   


    return (
      <>
      {/* For view sources of  */}
       <Modal
        title={`Sources: ${selectedGroupForAssign?.group_name??""}`}
        visible={null!=selectedGroupForAssign.group_id}
        width={'80%'}
        bodyStyle={{
          maxHeight:'80vh',
          overflowY:'scroll'
        }}
        okButtonProps={{
          loading:this.assignSelectedSourcesForGroupExecutor?.response()?.fetching,
          disabled:selectedSourceIds.length===0
        }}
        onOk={()=>{
          this.assignSelectedSourcesForGroupExecutor.execute({
            group_id:selectedGroupForAssign.group_id,
            source_ids:selectedSourceIds
          })
        }}
        okText="Submit"
        onCancel={()=>{
          this.setState({
            selectedGroupForAssign:{},
            selectedSourceIds:[]
          })
        }}
        centered
        // footer={null}
      >
       <ErrorWrapper 
       error={listSourcesForGroupExecutorResp} 
       onReload={()=>{
        this.listSourcesForGroupExecutorResp.execute()
       }}>
        <div>
       <Table
          className='main-table'
          locale={{
            emptyText:'There are either no any sources for this group or all sources have been assigned to the user.'
          }}
          scroll={{x:true}}
            loading={listSourcesForGroupExecutorResp.fetching}
            pagination={ <Pagination defaultCurrent={1} total={sourceListForGroup.length} />}
            rowClassName='custom-padding'
            style={{ "--paddingval": 2 }}
            dataSource={sourceListForGroup}
            size='small' columns={[
              {
                title:"",
                width:50,
                render:(id,record)=>{
                  return <Checkbox checked={selectedSourceIds.includes(record.id)} onChange={()=>{
                    this.onSelectSource(record.id);
                  }}/>
                }
              },
              {
                title:"Source Name",
                dataIndex:'name'
              }
            ]} />

      </div>

       </ErrorWrapper>
      </Modal> 
        <Col style={{
          padding:'8px'
        }}>
          <center>
            <Title level={3} type='secondary'>Group List</Title>
          </center>
          <Row
            type='flex'
            style={{
              flexWrap: 'nowrap',
              alignItems: 'center',
              paddingBottom: 6
            }}>
            <Input.Search
              value={all_filter.query}
              placeholder="Search For"
              onChange={(e) => {
                this.stateUpdater({ stateKey: 'all_filter', valueKey: 'query', value: e.target.value,callback:()=>{
                  this.delay_1.onSearch(()=>{
                    this.list_groups.config({
                      params: {
                        ...all_filter,
                        page:1
                      }
                    }).execute();
                  })
                } })
              }}
            ></Input.Search>
            {/* <Button
              onClick={() => {
                this.stateUpdater({
                  stateKey: 'all_filter',
                  removeKey: 'query',
                  appendObj: {
                    page: 1
                  },
                  callback: () => {
                    console.log("callback");
                    this.list_groups.config({
                      params: {
                        ...all_filter
                      }
                    }).execute();
                  }
                })
              }}
              type='link'
              style={{
                color: 'red',
                paddingRight: 0
              }}>Clear</Button>
          */}
          </Row>
          <Table
          className='main-table'
          scroll={{x:true}}
            loading={list_groups_resp.fetching}
            // pagination={{
            //   position: 'bottom',
            //   onChange: (page_no, pageSize) => {
            //     this.stateUpdater({
            //       stateKey: 'all_filter',
            //       appendObj: {
            //         page: page_no,
            //         per_page: pageSize
            //       },
            //       callback: () => {
            //         this.list_groups.config({
            //           params: {
            //             ...all_filter
            //           }
            //         }).execute()
            //       }
            //     })
            //   },
            //   defaultCurrent: 1,
            //   current: list_groups_meta.pagination && parseInt(list_groups_meta.pagination.split('/')[0]),
            //   // defaultPageSize: 20,
            //   pageSize: (list_groups_meta && list_groups_meta.requested_count),

            //   total: (list_groups_meta && list_groups_meta.total_count),
            //   showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`

            // }}
            rowClassName='custom-padding'
            style={{ "--paddingval": 2 }}
            dataSource={list_groups_rows}
            size='small' columns={all_data_cols({
              onClickViewSources:(record)=>{},
              onClickSelectSource:(record)=>{
                //
                let selectedIds=Object.keys(record.assigned??{});
                this.listSourcesForGroupExecutor.config({
                  params:{
                    group_id:record.group_id
                  }
                }).execute()
                this.setState({
                  selectedGroupForAssign:record,
                  selectedSourceIds:selectedIds
                });
              },
              onClickAssignAll:(record)=>{
                this.assignAllSourcesForGroupExecutor.execute({
                  group_id:record.group_id
                })
              },
              onClickRemoveAll:(record)=>{
                this.removeAllSourcesForGroupExecutor.execute({
                  group_id:record.group_id
                })
              },
                })} />

        </Col>
      </>
    );
  }
}

export default withDomains(GroupAssigner, "users","groups");
